export const GET_STATE = "GET_STATE";

//success or error response from the api
export const GET_STATE_SUCCESS = "GET_STATE_SUCCESS";
export const GET_STATE_FAIL = " GET_STATE_FAIL";

//GetAll Occupation actions   
export const GET_OCCUPATION = "GET_OCCUPATION";

export const GET_OCCUPATION_SUCCESS = "GET_OCCUPATION_SUCCESS";
export const GET_OCCUPATION_FAIL = "GET_OCCUPATION_FAIL";

//GetAll Related_Person_Type
export const GET_RELATEDPERSONTYPE = "GET_RELATEDPERSONTYPE";

export const GET_RELATEDPERSONTYPE_SUCCESS = "GET_RELATEDPERSONTYPE_SUCCESS";
export const GET_RELATEDPERSONTYPE_FAIL = "GET_RELATEDPERSONTYPE_FAIL";

//GetAll Education
export const GET_EDUCATION = "GET_EDUCATION";

export const GET_EDUCATION_SUCCESS = "GET_EDUCATION_SUCCESS";
export const GET_EDUCATION_FAIL = "GET_EDUCATION_FAIL";

//GetAll OccupationDetails
export const GET_OCCUPATIONDETAILS = "GET_OCCUPATIONDETAILS";

export const GET_OCCUPATIONDETAILS_SUCCESS = "GET_OCCUPATIONDETAILS_SUCCESS";
export const GET_OCCUPATIONDETAILS_FAIL = "GET_OCCUPATIONDETAILS_FAIL";

//GetAll AssetDetails
export const GET_ASSETDETAILS = "GET_ASSETDETAILS";

export const GET_ASSETDETAILS_SUCCESS = "GET_ASSETDETAILS_SUCCESS";
export const GET_ASSETDETAILS_FAIL = "GET_ASSETDETAILS_FAIL";

//GetAll OtherBankAccounts
export const GET_OTHERBANKACCOUNTS = "GET_OTHERBANKACCOUNTS";

export const GET_OTHERBANKACCOUNTS_SUCCESS = "GET_OTHERBANKACCOUNTS_SUCCESS";
export const GET_OTHERBANKACCOUNTS_FAIL = "GET_OTHERBANKACCOUNTS_FAIL";

//GetAll AccountType
export const GET_ACCOUNTTYPE = "GET_ACCOUNTTYPE";

export const GET_ACCOUNTTYPE_SUCCESS = "GET_ACCOUNTTYPE_SUCCESS";
export const GET_ACCOUNTTYPE_FAIL = "GET_ACCOUNTTYPE_FAIL";

//GetAll EntityType
export const GET_ENTITYTYPE = "GET_ENTITYTYPE";

export const GET_ENTITYTYPE_SUCCESS = "GET_ENTITYTYPE_SUCCESS";
export const GET_ENTITYTYPE_FAIL = "GET_ENTITYTYPE_FAIL";

//GetAll Location
export const GET_LOCATION = "GET_LOCATION";

export const GET_LOCATION_SUCCESS = "GET_LOCATION_SUCCESS";
export const GET_LOCATION_FAIL = "GET_LOCATION_FAIL";

// GetByLocationId Branch
export const GET_BRANCH = "GET_BRANCH";

export const GET_BRANCH_SUCCESS = "GET_BRANCH_SUCCESS";
export const GET_BRANCH_FAIL = "GET_BRANCH_FAIL";

//GetAll Poi
export const GET_POI = "GET_POI";

export const GET_POI_SUCCESS = "GET_POI_SUCCESS";
export const GET_POI_FAIL = "GET_POI_FAIL";


//GetAll Reason To Become a Customer
export const GET_REASON_TO_BECOME_CUSTOMER = "GET_REASON_TO_BECOME_CUSTOMER";

export const GET_REASON_TO_BECOME_CUSTOMER_SUCCESS = "GET_REASON_TO_BECOME_CUSTOMER_SUCCESS";
export const GET_REASON_TO_BECOME_CUSTOMER_FAIL = "GET_REASON_TO_BECOME_CUSTOMER_FAIL";